import React from 'react';
import {useTranslation} from 'react-i18next';

import {getIconUrl} from '../../../services/content-type/share-modal';

const TrendComments = () => {
  const isDesktop = window.Site?.targeting.platform === 'desktop';
  const {t} = useTranslation();

  return isDesktop
    ? null
    : (
      <aside className="bottom-nav-menu trend-bottom-nav">
        <div
          className="
          bottom-nav-menu__button bottom-nav-menu__button--share js-share bottom-nav-menu__button--share-trend"
        >
          <img
            src={`${getIconUrl('article/article-share-icon-white')}`}
            loading="lazy"
            alt="share icon"
            width="20"
            height="20"
          />
          <p className="bottom-nav-menu__button-text bottom-nav-menu__button-text-share">{t('shareTrend')}</p>
        </div>
      </aside>
    );
};

export {TrendComments};
